// extracted by mini-css-extract-plugin
module.exports = {"pdf-header":"styles-m__pdf-header__KTq_p","brand-logo":"styles-m__brand-logo__2FY7U"};